<template>
  <portal-context-required-template>
    <page-title :filteredInvoicePaymentHistory.sync='filteredInvoicePaymentHistory'/>
    <div container v-html="payment_history_header"></div>
    <payment-history-table @updateFilteredInvoicePaymentHistory='updatePaymentHistory' />
  </portal-context-required-template>
</template>

<script>
  import PageTitle from './PaymentHistory/PageTitle'
  import PaymentHistoryTable from './PaymentHistory/PaymentHistoryTable'
  import fetchable from '@mixins/fetchable'
  // import billing from '@mixins/billing'
  import { GET_INVOICE_PAYMENT_HISTORY } from '@store/modules/billing/actionTypes'
  import paymentVerbiage from '@mixins/paymentVerbiage';
  import { computed, onBeforeMount, ref, watch } from '@vue/composition-api';
  import { useStore, useRouter } from '@vue3shims';
  import { useBilling } from '@composables/useBilling';
  import { useGroupSelector } from '@composables/useGroupSelector';

  export default {
    mixins: [fetchable, paymentVerbiage],
    components: {
      PageTitle,
      PaymentHistoryTable
    },
    setup() {
      const store = useStore();
      const router = useRouter();
      const fetchers = [
        {
          action: GET_INVOICE_PAYMENT_HISTORY,
          // shouldFetch: this.$store.state.portalContext.portalContextSelected
          shouldFetch: store.getters['groupSelector/hasSelection'],
        }
      ];
      const filteredInvoicePaymentHistory = ref([]);
      const {
        hasSelection,
        selected,
      } = useGroupSelector();
      const {
        paymentHistoryEnabled,
      } = useBilling();

      const updatePaymentHistory = (history) =>  {
        filteredInvoicePaymentHistory.value = history;
      }
      const bounce = () => {
        router.push({
          name: 'billing-overview'
        }, () => {
          store.commit('SET_ANNOUNCEMENT_WARNING');
          store.commit('SET_ANNOUNCEMENT', 'Your selected subgroup cannot access payment history.');
        });
      }
      const fetchData = () => {
        if(hasSelection.value === true) {
          store.dispatch(GET_INVOICE_PAYMENT_HISTORY);
        }
      }

      onBeforeMount(() => {
        if(!paymentHistoryEnabled.value && store.getters['groupSelector/hasSelection']) {
          bounce();
        }
      });

      watch(selected, () => {
          fetchData();
      });

      return {
        bounce,
        fetchers,
        filteredInvoicePaymentHistory,
        updatePaymentHistory,
      }
    },
  }
</script>
